import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Burger, Image } from '@mantine/core';
import { THEME_COLORS } from '../../theme/ThemeConstants';
import { LAYOUT_CONSTANTS, Z_INDEX } from './LayoutConstants';
import { useStore } from '../../state';
import { CartIconButton } from '../cart/CartIconButton';
import { getRuntimeEnvironment } from '@trappedmc/docker-frontend-runtime-env';

interface MobileHeaderProps {
  isOpen: boolean;
  onToggle: () => void;
}

const { REACT_APP_FULL_URL = '' } = getRuntimeEnvironment();

const headerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: LAYOUT_CONSTANTS.MOBILE_HEADER_HEIGHT,
  backgroundColor: 'rgba(15, 15, 15, 0.6)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 16px',
  zIndex: Z_INDEX.MOBILE_HEADER,
  borderBottom: '1px solid rgba(255, 255, 255, 0.08)'
};

const burgerContainerStyle: React.CSSProperties = {
  position: 'absolute',
  left: 16
};

const cartContainerStyle: React.CSSProperties = {
  position: 'absolute',
  right: 16
};

const logoStyle: React.CSSProperties = {
  width: '40px',
  height: '40px'
};

export const MobileHeader: React.FC<MobileHeaderProps> = observer(({ isOpen, onToggle }) => {
  const { cartStore } = useStore();

  return (
    <Box style={headerStyle}>
      <Box style={burgerContainerStyle}>
        <Burger
          opened={isOpen}
          onClick={onToggle}
          size='sm'
          color={THEME_COLORS.text.primary}
          aria-label='Toggle navigation'
        />
      </Box>

      <Image src={`${REACT_APP_FULL_URL}/assets/images/logo.png`} alt='Server Logo' style={logoStyle} />

      <Box style={cartContainerStyle}>
        <CartIconButton color={THEME_COLORS.text.primary} />
      </Box>

      {/* Temporarily hidden currency selector */}
      {/* <Select
        value={cartStore.selectedCurrency}
        onChange={(value) => value && cartStore.setSelectedCurrency(value)}
        data={[
          { value: 'AUD', label: 'AUD' },
          { value: 'CAD', label: 'CAD' },
          { value: 'EUR', label: 'EUR' },
          { value: 'GBP', label: 'GBP' },
          { value: 'HKD', label: 'HKD' },
          { value: 'JPY', label: 'JPY' },
          { value: 'USD', label: 'USD' }
        ]}
        size="sm"
        w={80}
        styles={{
          input: {
            backgroundColor: THEME_COLORS.accent.primary,
            border: 'none',
            color: THEME_COLORS.text.primary,
            fontWeight: 600
          }
        }}
      /> */}
    </Box>
  );
});
